import { gql, useMutation } from '@apollo/client';
import { useEventCallback } from '@mui/material/utils';
import { DateTime } from 'luxon';

type StopStopwatchVariables = {
  id: string;
  stopTime: string;
};

type StopStopwatchResponse = {
  stopStopwatch: {
    code: string;
  };
};

const STOP_STOPWATCH_MUTATION = gql`
  mutation stopstopwatch($id: ID!, $stopTime: DateTimeEx!) {
    stopStopwatch(id: $id, stopTime: $stopTime) {
      code
    }
  }
`;

export const useStopStopwatch = () => {
  const [mutate] = useMutation<StopStopwatchResponse, StopStopwatchVariables>(
    STOP_STOPWATCH_MUTATION
  );

  return useEventCallback(async (id: string) => {
    return mutate({
      variables: {
        id,
        stopTime: DateTime.now().toISO(),
      },
    });
  });
};
